import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { TopProductsFields } from '../helpers';

export const useGetTopProductsValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  return {
    [TopProductsFields.PRODUCT_ID]: [requiredRule],
  };
};
